/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class CertExamApplyRemarks extends Ce {
    constructor() {
        super();
        this.baseUrl += '/certExamApplyRemarks';
    }

    save({ certExamApplyId, remarks, colorMark } = {}) {
        return super.post('/save', {
            certExamApplyId,
            remarks,
            colorMark,
        });
    }
}

export default new CertExamApplyRemarks();
export { CertExamApplyRemarks };
